document.addEventListener('DOMContentLoaded', () => {
    const swipers = document.querySelectorAll('.imageslider');

    if (!swipers.length) return;

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(async (entry) => {
            if (entry.isIntersecting) {
                const element = entry.target;

                // Stop watching this element so it only loads once
                observerInstance.unobserve(element);

                try {
                    // Dynamically import Swiper JS modules and CSS concurrently
                    const [{ default: Swiper }, { Navigation }] = await Promise.all([
                        import('swiper'),
                        import('swiper/modules'),
                        import('swiper/css'),
                        import('swiper/css/navigation')
                    ]);

                    const slidesToShow = parseInt(element.dataset.slidestoshow, 10) || 1;
                    const autoplay = element.dataset.autoplay === 'true';

                    new Swiper(element, {
                        modules: [Navigation],
                        slidesPerView: slidesToShow,
                        loop: true,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        autoplay: autoplay
                    });
                } catch (error) {
                    console.error('Error loading Swiper dynamic imports:', error);
                }
            }
        });
    }, { rootMargin: '200px' }); // Preloads 200px before scrolling into view

    swipers.forEach((element) => observer.observe(element));
});